import './assets/css/style.scss';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Loading } from 'components';
import App from './App';
import {
  disableServiceWorker,
  SERVICE_WORKER_ENABLED,
  register,
} from './serviceWorkerRegistration';
import 'translation';

if (SERVICE_WORKER_ENABLED) {
  register();
} else {
  // Clear stale SW/caches that cause white screen; do not register again.
  disableServiceWorker();
}

const root = createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<Loading />}>
    <App />
  </Suspense>
);
